<div>
    <div class="w-450px">
        <iui-messages #message  class="ms-auto me-auto"></iui-messages>
    </div>
    <form #userForm="ngForm" name="userForm">
        <div class="row" *ngIf="displayFilter"> 
            <div class="col-md-8">
                <h5 id="headerLabel"> No new data will be available for this report after 10/15/2024</h5>
            </div>
            <div class="col-md-8">
                <h5 id="headerLabel"> Report Results will be from {{brandCountResponse?.data?.brandid?.reportDateTime| date: "M/d/YYYY"}}</h5>
            </div>
            <div class="col-md-4">
                <button class="btn btn-primary"  (click)="onDownload()">Download Complete
                    Report</button> 
            </div>
        </div>
        <br>
        <div class="row">
         

            <div class="row ms-1 ">
                <span><span>Ownership Status Count - </span><span class="ps-0 fw-bold">Dedicated :
                    </span>
                    {{brandCountResponse?.data?.brandid?.dedicatedCount}} <span
                        class="ps-0 fw-bold">&nbsp;&nbsp;Shared : </span>
                    {{brandCountResponse?.data?.brandid?.sharedCount}} <span
                        class="ps-0 fw-bold">&nbsp;&nbsp;Unverified : </span>
                    {{brandCountResponse?.data?.brandid?.unverifiedCount}} <span
                        class="ps-0 fw-bold">&nbsp;&nbsp;Unknown : </span>
                    {{brandCountResponse?.data?.brandid?.unknownCount}}</span>
            </div>
            <div class="row ms-1 mt-2">
                <div class="col-md-4 ps-0">
                    <div>
                        <label for="role">Short Codes</label>
                    </div>
                    <div>
                        <div class="col-12 ps-0">
                            <textarea style="width: 100%;" appAlphaNumOnly [(ngModel)]="enteredShortCode" name="ShortCode" id="ShortCode" rows="5"  wrap="hard" maxlength="34" 
                                [(ngModel)]="shortCodeFilter" pInputTextarea class="form-control mb-1"
                                (keypress)="keyPressNumbers($event)"></textarea>
                        </div>
                        <div class="col-12 ps-0" style="margin-top: -0.6rem;">
                            <span style="font-size: .8rem; ">(Must be line separated)</span>
                        </div>
                    </div>

                </div>
                <div class="col-md-4 mb-3">
                    <label for="status">Status</label>
                    <p-multiSelect id="status" appTid class="p-formcontrol" name="status" appendTo="body"
                        [(ngModel)]="identificationPayload.statuses" placeholder="Nothing Selected"
                        [options]="statusList" optionLabel="label" optionValue="value" optionDisabled="disabled"
                        selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2" appTid>
                    </p-multiSelect>

                </div>
                <div class="col-md-4 mb-3 ">
                    <div>
                        <label for="contentProvider">Content Provider</label>
                    </div>
                    <div>
                        <input appScrText name="contentProvider" placeholder="(Contains)"
                            [(ngModel)]="identificationPayload.contentProvider" id="contentProvider" class="mt-0" />
                    </div>
                    <div class="mb-3 mt-3 ">
                        <label for="virticales">Verticals</label>
                        <p-multiSelect id="virticales" class="p-formcontrol" name="verticals" appendTo="body"
                            [(ngModel)]="identificationPayload.verticals" placeholder="Nothing Selected"
                            [options]="verticalList" optionLabel="label" optionValue="value" optionDisabled="disabled"
                            selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2">
                        </p-multiSelect>

                    </div>


                </div>
            </div>

            <div class="row ms-1">
                <div class="col-4 ps-0">
                    <label for="brands">Brands</label>

                    <input appScrText name="brands" placeholder="(Contains)" id="contentProvider"
                        [(ngModel)]="identificationPayload.brand" />
                </div>
            </div>
            <div class="row ms-1 mt-4">
                <div class="col-4 ps-0">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Get Report</button>
                    <button type="button" class="btn btn-secondary ms-3" (click)="onReset()">Reset Query</button>
                    
                </div>
            </div>
        </div>
        <div *ngIf="displayReport">
            <div style="height: 1rem;"></div>
            <div class="col-md-8">
                <h5 id="headerLabel">Results from {{brandCountResponse?.data?.brandid?.reportDateTime| date: "M/d/YYYY"}}</h5>
            </div>
            <p-table [value]="brandResponse" #brandIdTable
             styleClass="p-datatable-striped" 
             [scrollable]="true" scrollHeight="50vh"
             [columns]="tableColumn" 
             [paginator]="true"
             [rows]="rowsInPage"
             [alwaysShowPaginator]="false"
            currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})"
            [showCurrentPageReport]="true"
         
           [lazy]="true" (onPage)="loadLazyBrandId($event)" [totalRecords]='totalRecords'
            >
                <ng-template pTemplate="header" let-columns>
                    <tr *ngIf="totalRecords>0">
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="!col.sort">{{col.header}}</th>
                            <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width"
                                [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </ng-container>
                    </tr>
                    
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                            <div *ngSwitchCase="'shortCode'">
                                <a href="javascript:void(0)"
                                    (click)="navigateLookup(rowData)">{{rowData[col.field]}}</a>
                            </div>

                            <div *ngSwitchCase="'status'">
                                {{rowData.status}}
                            </div>
                            <div *ngSwitchCase="'contentProvider'">
                                {{rowData.contentProvider}}
                            </div>
                            <div *ngSwitchCase="'brands'">
                                <div *ngFor="let item of rowData.brands">{{item}}</div>

                            </div>
                            <div *ngSwitchCase="'verticals'">
                                <div *ngFor="let item of rowData.verticals">{{item}}</div>
                            </div>
                            <div *ngSwitchCase="'campaignTypes'">
                                <div *ngFor="let item of rowData.campaignTypes">{{item}}</div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length" class="noBorder">
                            <b>No Records found</b>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </form>
</div>